export default {"src":"/ui/_next/static/media/loading.5b375386.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};